var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyDemand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19449 8.44694H12.6826C14.0939 8.44694 15.2487 9.6019 15.2487 11.013V20.5012C15.2487 21.9124 14.0937 23.0672 12.6826 23.0672H3.19449C1.7832 23.0672 0.628418 21.9123 0.628418 20.5012V11.013C0.628418 9.60173 1.78338 8.44694 3.19449 8.44694ZM9.31878 0.943085H18.8069C20.2182 0.943085 21.373 2.09804 21.373 3.50916V12.9973C21.373 14.4086 20.218 15.5634 18.8069 15.5634H16.3266V11.0128C16.3266 9.00906 14.6871 7.3696 12.6834 7.3696H6.75322V3.50894C6.75322 2.09766 7.90818 0.942871 9.31929 0.942871L9.31878 0.943085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDemand);
export default __webpack_public_path__ + "static/media/CopyDemand.133f5c58df556b7318b87651bc30feec.svg";
export { ForwardRef as ReactComponent };